/* eslint-disable arrow-body-style */
import type { ReactNode, FC, Ref } from "react";
import { mergeClasses } from "@huub-web/utils";

import { Flex } from "../Flex/Flex";
import { TimelineEntry } from "./components/TimelineEntry";
import type { ClassNameProp } from "../../props";
import { containerStyle } from "./Timeline.css";

export type TimelineRecord<T = ReactNode> = {
  subtitle?: T;
  title: T;
  description?: T;
  trailing?: T;
  date?: Date;
  percentage?: number;
};

export type TimelineProps = ClassNameProp & {
  records: TimelineRecord[];
  /**
   * Ref forwarded to the root element
   */
  ref?: Ref<HTMLDivElement>;
};

export const Timeline: FC<TimelineProps> = ({
  records = [],
  className,
  ref,
  ...props
}) => {
  return (
    <Flex
      className={mergeClasses(className, containerStyle)}
      ref={ref}
      {...props}
      direction="column"
      gap="l"
    >
      {records.map((record, index) => (
        <TimelineEntry key={index} record={record} />
      ))}
    </Flex>
  );
};
